import { encryptRequest, produceAESKey } from "./cryptoHelper";
import { apiGet, apiPost } from "./apiClient";

const baseHeaders = { 'Content-Type': 'application/json' };

export const initializeSurveyCreateJob = async (token, obj) => {
    const { encryptedData, encryptedAESKey } = encryptRequest(obj);

    const requestInfo = {
        headers: { ...baseHeaders, Authorization: token },
        body: { encryptedData, encryptedAESKey },
    };

    return await apiPost('/survey-job', requestInfo);
};

export const getActiveSurveyProgress = async (token, type, surveyId) => {
    const { encryptedAESKey } = produceAESKey();
    const queryStringParameters = { encryptedKey: encryptedAESKey };
    if (surveyId) {
        queryStringParameters["survey_id"] = surveyId;
    }

    const requestInfo = {
        headers: { ...baseHeaders, Authorization: token },
        queryStringParameters,
    };

    return await apiGet(`/survey-job/${type}`, requestInfo);
};
